export default __webpack_public_path__ + "static/media/p7_game3.34832bc5.png";